// Native
import { useState } from "react"
import { useParams } from "react-router"

// Components
import { Badge, ButtonGroup, Divider, Tag, Td } from "@chakra-ui/react"
import { Dev, IconButton, Row, Scope, Searchable, Section, Stock, Table } from "components"

// Hooks
import { useDistributor, useDistributorStock, useUser } from "hooks"

// Screens
import Change from "./change"
import { Functions } from "config"

export default function Stocks(){

    const params = useParams()
    const user = useUser()
    const distributor = useDistributor(params.id)
    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const stock = useDistributorStock(distributor?.data?.id, page, term)
    const [ selectedStock, setSelectedStock ] = useState(false)
    
    const columns = [
        { children: 'Produto' }, 
        { children: 'Estoque', isNumeric: true }, 
        { children: 'Disponível', isNumeric: true }, 
        { children: '', isNumeric: true }
    ]

    return(
    <>
        <Section title="Visão geral do estoque">
            <ButtonGroup size="xs" isDisabled={stock.isFetching}>
                <IconButton label="Atualizar" icon="refresh" isLoading={stock.isFetching} onClick={stock.refetch} />
                <Dev data={stock} />
            </ButtonGroup>
        </Section>

        <Divider />
        
        <Searchable placeholder="Procurar por descrição, código do pedido ou produto..." value={term} setValue={setTerm}  />

        <Table columns={columns} loading={stock.isLoading} meta={stock.data?.meta} setPage={setPage}>
            { stock.data?.data?.map(item => <Item key={item.id} isDisabled={stock.isFetching} onClick={Functions.hasRole(user, 'distributors_stock') ? () => setSelectedStock(item) : null} data={item} />) }
        </Table>

        {/* Screens */}
        <Change isOpen={!!selectedStock} data={selectedStock} onClose={() => setSelectedStock(false)} />
    </>
    )
}

const Item = ({ data:item, isDisabled, ...props }) => (
    <Row opacity={!!item.stock ? null : 0.5} {...props}>
        <Td><Badge children={item.product?.name ?? item.product_kit?.label} /></Td>
        <Td isNumeric><Stock available={item.stock} reserved={item.reserved} /></Td>
        <Td isNumeric><Tag minW="40px" colorScheme="teal" children={item.available} /></Td>
        <Td isNumeric>
            <Scope role="distributors_stock"><IconButton size="xs" label="Ajustar estoque" icon="edit" isDisabled={isDisabled} /></Scope>
        </Td>
    </Row>
)